import { API_BASE_URL } from "../assets/const";
import {createNotification} from "../components/Notifications/Notifications";
import {checkAndUpdateToken} from "./auth";
import {buildDefaultHeaders} from "./helper";
import {
    GET_USER_DICT_LIST, SET_USER_DICT_LIST_LOADING,
    // SET_USER_DICT_BY_ID
} from "./types";

export const getUserDictList = () => async(dispatch, getState) => {
    dispatch({type: SET_USER_DICT_LIST_LOADING, payload: true});
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${API_BASE_URL}/user_dictionary`, {
            method: "GET",
            ...buildDefaultHeaders(getState)
        });
        if (response.ok) {
            const result = (await response.json());
            dispatch({type: GET_USER_DICT_LIST, payload: result});
        }
    }
    dispatch({type: SET_USER_DICT_LIST_LOADING, payload: false});
};

export const updateUserDict = (params) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {

        const response = await fetch(`${API_BASE_URL}/user_dictionary/${params.vocabulary_id}`, {
            method: "PUT",
            body: JSON.stringify(params),
            ...buildDefaultHeaders(getState)
        });
        if (response.ok) {
            await dispatch(getUserDictList());
            createNotification('success', 'Успешно!');
        }
    };
}

export const createUserDict = (data) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${API_BASE_URL}/user_dictionary`, {
            method: "POST",
            body: JSON.stringify(data),
            ...buildDefaultHeaders(getState)
        });
        if (response.ok) {
            createNotification('success', 'Успешно');
            await dispatch(getUserDictList());
        } else 
            createNotification('error', "Не удалось создать запись");
        }
    };

export const deleteUserDict = (id) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${API_BASE_URL}/user_dictionary/${id}`, {
            method: "DELETE",
            ...buildDefaultHeaders(getState)
        });
        const result = await response.json();

        if (response.ok) {
            createNotification('success', 'Успешно');
            await dispatch(getUserDictList());
        } else 
            createNotification('error', result.error);
        }
    };


// export const getUserDictList = (id) => async (dispatch, getState) => {
//   await dispatch(checkAndUpdateToken());
//   if (getState().auth.token) {
//     const response = await fetch(`${API_BASE_URL}/track_profile/${id} `, {
//       method: "GET",
//       ...buildDefaultHeaders(getState),
//     });
//     if (response.ok) {
//       const result = (await response.json());

//       dispatch({ type: SET_USER_DICT_BY_ID, payload: result });
//     }
//   }
// };